import { CreditCardIcon } from "@heroicons/react/16/solid";

import Tooltip from "~/components/Tooltip.tsx";
import { formatCentsToCurrency } from "~/utils/currencyUtils.ts";

type Props = {
	budgetCents?: number;
};

const QuotaTopUpBudgetDisplay = ({ budgetCents = 0 }: Props) => {
	const formattedValue = formatCentsToCurrency(budgetCents, 0);
	return <Tooltip text={`Das Budget beinhaltet ${formattedValue} aus Kontingenten.`}>
		<div className="flex items-center justify-center text-gray-500">
			<span>{formattedValue}</span>
			<CreditCardIcon className="ml-1 size-3 text-gray-400" />
		</div>
	</Tooltip>;
};

export default QuotaTopUpBudgetDisplay;